var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"display-1 info--text"},[_vm._v(" Sistema de Controle de Adesões ")]),_c('br'),_c('h3',{staticClass:"subtitle-1 info--text"},[_vm._v("Versão: "+_vm._s(_vm.fAppVersion))]),_c('br'),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }